import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c27145e")

_pushScopeId("data-v-1c27145e")
const _hoisted_1 = { class: "text-sm font-medium mb-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!

  return (_ctx.options.length > 0)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        "data-testid": `${_ctx.testIdPrefix}-last-location`
      }, [
        _createVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("urgentDeliveryManagement.filter.lastLocation")), 1),
        _createVNode(_component_CustomDropdown, {
          placeholder: _ctx.displayPlaceholder,
          modelValue: _ctx.lastLocationModel
        }, {
          default: _withId(() => [
            _createVNode("div", {
              class: "w-full pl-2.5 py-2 relative max-h-250px overflow-y-auto",
              "data-testid": `${_ctx.testIdPrefix}-last-location-options`
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dropdownOptions, (location, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: `location-${index}`,
                  "data-testid": `${_ctx.testIdPrefix}-last-location-${index}`,
                  class: "flex items-center p-field-checkbox mt-2"
                }, [
                  _createVNode(_component_Checkbox, {
                    value: location.value,
                    inputId: `location-${index}`,
                    name: `location-${index}`,
                    modelValue: _ctx.selectedLastLocations,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedLastLocations = $event)),
                    onChange: _ctx.onLastLocationChange
                  }, null, 8, ["value", "inputId", "name", "modelValue", "onChange"]),
                  _createVNode("label", {
                    class: "ml-2.5",
                    for: `location-${index}`
                  }, _toDisplayString(location.label), 9, ["for"])
                ], 8, ["data-testid"]))
              }), 128))
            ], 8, ["data-testid"])
          ]),
          _: 1
        }, 8, ["placeholder", "modelValue"])
      ], 8, ["data-testid"]))
    : _createCommentVNode("", true)
})